export const TypeKey = "____type";
export const KindKey = "____kind";
export const CustomType = "____CustomType";
export const UnionType = "____UnionType";
export const UnionCases = "____UnionCases";
export const UnionCase = "____UnionCase";
export const UnionValues = "____UnionValues";
